module.exports = __webpack_public_path__ + "static/media/rtu.6f2cd74e.svg";